import { createIntl, createIntlCache } from 'react-intl'
import AppLanguage from 'languages'
import { getCurrentLanguage } from 'utils'

const cache = createIntlCache()
export default () => {
  const currentLanguage = getCurrentLanguage()
  return createIntl(
    {
      locale: currentLanguage,
      messages: AppLanguage['react-intl'][currentLanguage].messages,
    },
    cache
  )
}
